import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { AuthenticationService } from '../../services/authentication.service';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  DictionaryService,
  languages,
} from '../../services/dictionary.service';
import { ButtonDirective } from '../button/button.directive';
import { TimeRangeModalComponent } from '../time-range-modal/time-range-modal.component';
import { routes, routesIcons } from './routes.data';

@Component({
  selector: 'app-navbar',
  imports: [
    NgIcon,
    RouterModule,
    CommonModule,
    ButtonDirective,
    TimeRangeModalComponent,
  ],
  providers: [
    provideIcons({
      ...routesIcons,
    }),
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  protected authService = inject(AuthenticationService);
  protected dictionaryService = inject(DictionaryService);

  protected isTimeRangeModalOpen = signal<boolean>(false);

  protected userName = signal<string>('');

  // Reactive computed values that automatically update when underlying data changes
  protected userInitial = computed(() => {
    const name = this.userName();
    return name.charAt(0).toUpperCase();
  });

  protected permittedRoutes = computed(() => {
    const userPolicy = this.authService.currentUserPolicy;
    return userPolicy?.menuItems || [];
  });

  protected routes = computed(() => {
    const permittedRoutes = this.permittedRoutes();
    return routes(permittedRoutes, this.dictionaryService);
  });

  setLanguage(language: 'ar' | 'en') {
    this.dictionaryService.setLanguage(
      language === 'ar' ? languages.Arabic : languages.English,
    );
  }

  openTimeRangeModal() {
    this.isTimeRangeModalOpen.set(true);
  }

  closeTimeRangeModal() {
    this.isTimeRangeModalOpen.set(false);
  }

  async ngOnInit() {
    const userData = await this.authService.getUserData();
    if (userData) {
      this.userName.set(userData.name);
    }
  }
}
